"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var moment = require("moment-timezone");

exports.default = {
  props: ["occasions"],

  data: function data() {
    return {
      posting: false,
      occasion: {},
      time: null,
      loaded: false,
      user: window.globals.user,
      date: {},
      type: {},
      location: {}
    };
  },
  mounted: function mounted() {
    this.setOccasion(this.$parent.params);
    this.loaded = true;
  },


  computed: {
    url: function url() {
      if (!this.time) {
        return;
      }

      return "/occasion/" + this.occasion.id + "/employee/" + this.user.id + "/time/" + this.time.id;
    },
    futureOccasions: function futureOccasions() {
      return this.occasion.free_times.filter(function (date) {
        return moment(date.time).isAfter(moment());
      });
    },
    types: function types() {
      return _(this.futureOccasions).map(function (item) {
        return item.type;
      }).uniqBy(function (item) {
        return item.id;
      }).value();
    },
    locations: function locations() {
      var _this = this;

      return _(this.futureOccasions).filter(function (item) {
        return item.type.id === _this.type.id;
      }).map(function (item) {
        return item.location;
      }).uniqBy(function (item) {
        return item.id;
      }).value();
    },
    filteredItems: function filteredItems() {
      var _this2 = this;

      return this.futureOccasions.filter(function (item) {
        return item.type.id === _this2.type.id && item.location.id === _this2.location.id;
      });
    },
    dates: function dates() {
      return _(this.filteredItems).groupBy(function (date) {
        return moment(date.time).format("YYYY-MM-DD");
      }).map(function (date, index) {
        return { id: index, name: index + " (" + date.length + " tider)" };
      }).value();
    },
    times: function times() {
      var _this3 = this;

      return _(this.filteredItems).filter(function (date) {
        return moment(date.time).format("YYYY-MM-DD") === _this3.date.id;
      }).map(function (date) {
        date.name = moment(date.time).format("HH:mm");
        return date;
      }).value();
    }
  },

  methods: {
    setType: function setType(type) {
      this.type = type;
      this.location = {};
    },
    setLocation: function setLocation(location) {
      this.location = location;
      this.date = {};
    },
    setDate: function setDate(date) {
      this.date = date;
      this.time = {};
    },
    setTime: function setTime(time) {
      this.time = time;
    },
    setOccasion: function setOccasion(id) {
      this.occasion = _(this.occasions).find({ id: id });
    },
    validate: function validate(e) {
      e.preventDefault();
      this.posting = true;

      if (!this.validateInput(this.type.id, "dashboard.messages.select_type")) {
        return;
      }

      if (!this.validateInput(this.location.id, "dashboard.messages.select_location")) {
        return;
      }

      if (!this.validateInput(this.date.id, "dashboard.messages.select_date_and_time")) {
        return;
      }

      if (!this.validateInput(this.time.id, "dashboard.messages.select_date_and_time")) {
        return;
      }

      this.$refs.form.submit();
    },
    validateInput: function validateInput(input, warningMessage) {
      if (!input) {
        this.$toastr.warning(this.$t(warningMessage));
        this.posting = false;

        return false;
      }

      return true;
    },
    getTimezone: function getTimezone() {
      return moment.tz.guess();
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/menu/BookTimeMenu.vue
// module id = BJFo
// module chunks = 0 1